/**
 * Thrown by the queue hook when a decision was saved but the queue could not be
 * reloaded afterwards. Callers word it as "saved, could not reload" — never as a
 * failed decision, which would invite re-deciding the same row.
 */
export class ModerationReloadError extends Error {
  /** What the reload failed with. */
  readonly reason: unknown

  constructor (reason: unknown) {
    super(reason instanceof Error ? reason.message : 'Could not reload the queue')
    this.name = 'ModerationReloadError'
    this.reason = reason
    Object.setPrototypeOf(this, ModerationReloadError.prototype)
  }
}
